<template>
	<div>
		<!-- 船厂要闻 -->
		<div class="publist_warp" v-if="this.ccywList.length">
			<div class="publist_warp_title">
				<div class="left_title">船厂要闻</div>
				<router-link tag="div" class="right_title" :to="{path:'/jryw'}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in ccywList" :key="index" @click="xgyd(item.id,item.title)">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div>
		<!-- 订单播报 -->
		<div class="publist_warp" style="margin-top:10px;" v-if="this.ddbbList.length">
			<div class="publist_warp_title">
				<div class="left_title">订单播报</div>
				<router-link tag="div" class="right_title" :to="{path:'/ddbb'}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in ddbbList" :key="index" @click="xgyd(item.id,item.title)">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div>
		<!-- 船配快讯 -->
		<div class="publist_warp" style="margin-top:10px;" v-if="this.cpkxList.length">
			<div class="publist_warp_title">
				<div class="left_title">船配快讯</div>
				<router-link tag="div" class="right_title" :to="{path:'/cbgc'}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in cpkxList" :key="index" @click="xgyd(item.id,item.title)">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div>
		<!-- 船东要闻 -->
		<div class="publist_warp" style="margin-top:10px;" v-if="this.cdywLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">船东要闻</div>
				<router-link tag="div" class="right_title" :to="{path:'/hygc'}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in cdywLsit" :key="index" @click="xgyd(item.id,item.title)">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div>
		<!-- 海洋油气 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.hyyqLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">海洋油气</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'6',name:'海洋油气'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in hyyqLsit" :key="index" @click="xgyd(item.id,'海洋油气')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 船舶工程 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.cbgcLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">船舶工程</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'3',name:'船舶工程'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in cbgcLsit" :key="index" @click="xgyd(item.id,'船舶工程')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 海洋平台 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.hygcLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">海洋平台</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'10',name:'海洋平台'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">

				<div class="pub_list_q" v-for="(item,index) in hygcLsit" :key="index" @click="xgyd(item.id,'海洋平台')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 船舶设计 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.cbsjLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">船舶设计</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'8',name:'船舶设计'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">

				<div class="pub_list_q" v-for="(item,index) in cbsjLsit" :key="index" @click="xgyd(item.id,'船舶设计')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 技术交流 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.jsjlLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">技术交流</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'33',name:'技术交流'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">

				<div class="pub_list_q" v-for="(item,index) in jsjlLsit" :key="index" @click="xgyd(item.id,'技术交流')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 专家讲堂 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.zjjtLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">专家讲堂</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'31',name:'专家讲堂'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">

				<div class="pub_list_q" v-for="(item,index) in zjjtLsit" :key="index" @click="xgyd(item.id,'专家讲堂')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
		<!-- 主流船型 -->
		<!-- <div class="publist_warp" style="margin-top:10px;" v-if="this.zlcxLsit.length">
			<div class="publist_warp_title">
				<div class="left_title">主流船型</div>
				<router-link tag="div" class="right_title" :to="{path:'/hyzxdetail',query:{id:'34',name:'主流船型'}}">
					更多&nbsp;&nbsp;&#62;&#62;
				</router-link>
			</div>
			<div class="pub_list">
				<div class="pub_list_q" v-for="(item,index) in zlcxLsit" :key="index" @click="xgyd(item.id,'主流船型')">
					<div class="public_q_title">{{item.title}}</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				// other
				ccywList: [],
				cdywLsit: [],
				ddbbList: [],
				cpkxList: [],
				cbgcLsit: [],
				hyptList: [],
				hyyqLsit: [],
				hygcLsit: [],
				cbsjLsit: [],
				jsjlLsit: [],
				zjjtLsit: [],
				zlcxLsit: [],
				rightList:[]
			}
		},
		async mounted() {
			let res1 = await http.get('api/industry/content?id=1645')
			this.rightList = res1.data.data.right
		},
		watch: {
			rightList() {
				this.rightList.filter(item => {
					if (item.fid == 3) {
						this.ccywList.push(item)
					} else if (item.fid == 2) {
						this.cdywLsit.push(item)
					} else if (item.fid == 1) {
						this.ddbbList.push(item)
					} else if (item.fid == 13) {
						this.cpkxList.push(item)
					} else if (item.fid == 6) {
						this.hyyqLsit.push(item)
					} else if (item.fid == 4) {
						this.cbgcLsit.push(item)
					} else if (item.fid == 10) {
						this.hyptList.push(item)
					} else if (item.fid == 8) {
						// 船舶设计
						this.cbsjLsit.push(item)
					} else if (item.fid == 33) {
						// 技术交流
						this.jsjlLsit.push(item)
					} else if (item.fid == 31) {
						// 专家讲堂
						this.zjjtLsit.push(item)
					} else if (item.fid == 34) {
						// 主流船型
						this.zlcxLsit.push(item)
					}
				})
			}
		},
		methods: {
			xgyd(id, resq) {
				this.$router.push({
					path: '/hyzxdetail',
					query: {
						id: id,
						title: resq
					}
				})
				// console.log(id, resq)
				// this.$axios({
				// 	headers: {
				// 		'Authorization': this.$storage.getItem("token")
				// 	},
				// 	url: 'https://admin.shipoe360.com/api/picture/contents',
				// 	method: "get",
				// 	params: {
				// 		id: id
				// 	}
				// }).then(res => {
				// 	console.log(res)
				// 	this.$emit('xgyd', res, resq)
				// })
			},
		}
	}
</script>

<style scoped>
	.pub_list .pub_list_q::after,
	.publist_warp_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.publist_warp_title {
		padding: 12px 0;
		background-color: red;
	}

	.left_title {
		font-size: 20px;
		font-weight: 800;
		float: left;
		color: #fff;
		padding-left: 10px;
	}

	.right_title {
		color: #fff;
		font-size: 14px;
		float: right;
		line-height: 22px;
		cursor: pointer;
		margin-right: 8px;
	}

	.pub_list .pub_list_q {
		cursor: pointer;
		font-size: 14px;
		margin: 6px 0;
	}

	.pub_list {
		border: 1px solid #f0f0f0;
		overflow: hidden;
	}

	.public_q_p {
		float: right;
		padding: 2px 8px;
	}

	.public_q_title {
		float: left;
		width: calc(100%);
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		padding: 1px 8px;
	}

	.detail_warp {
		overflow: hidden;
		height: 180px;
		margin-top: 10px;
	}

	.detail_warp>img {
		width: 100%;
		height: 100%;
	}

	@media screen and (min-width: 1200px) {
		.detail_warp {
			height: 190px;
		}
	}

	@media screen and (min-width: 1500px) {
		.detail_warp {
			height: 220px;
		}
	}
	
	.public_q_title:hover{
		color: blue;
		text-decoration:underline; 
	}
</style>
